import * as Sentry from "@sentry/react";

let aggregatorURL = import.meta.env.VITE_AGGREGATOR_URL;
if (aggregatorURL === undefined && import.meta.env.MODE === "development") {
  aggregatorURL = "http://localhost:5000";
}

export async function fetchPosts(groupCode) {
  try {
    const response = await fetch(
      `${aggregatorURL}/edubox/posts/${encodeURIComponent(groupCode)}`,
      {
        headers: {
          Authorization: `token ${import.meta.env.VITE_AGGREGATOR_KEY}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    Sentry.captureException(error);

    return null;
  }
}
